import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import helpers from 'src/styles/helpers';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, helpers), {}, {
  statement: {
    boxShadow: palette.shadows.light,
    backgroundColor: palette.shades[100],
    '& + &': {
      marginTop: '20px'
    }
  },
  statementHeader: {
    padding: '18px 24px',
    backgroundColor: palette.shades[100],
    boxShadow: palette.shadows.light,
    borderRadius: '2px 2px 0 0',
    '& p': {
      marginTop: '4px'
    }
  },
  statementRow: {
    padding: '18px 24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& + &': {
      borderTop: "1px solid ".concat(palette.shades[300])
    },
    [breakpointsFunc.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  },
  statementSummary: {
    backgroundColor: palette.shades[200],
    borderRadius: '0 0 2px 2px',
    padding: '18px 32px',
    textAlign: 'right',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    [breakpointsFunc.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-end'
    }
  },
  actionIcons: {
    marginLeft: '20px',
    display: 'flex',
    [breakpointsFunc.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  utilityPriceChangeIcon: {
    margin: '0 12px'
  },
  prevUtilityCost: {
    color: palette.shades[600],
    textDecoration: 'line-through'
  },
  utilityCredit: {
    color: palette.primary.main,
    position: 'relative',
    '&:before': {
      content: "'+'",
      marginRight: '4px'
    }
  },
  costWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [breakpointsFunc.breakpoints.down('md')]: {
      marginLeft: '20px'
    },
    [breakpointsFunc.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      marginTop: '15px',
      marginLeft: '0'
    }
  },
  cost: {
    [breakpointsFunc.breakpoints.down('sm')]: {
      marginTop: '5px'
    }
  },
  total: {
    marginLeft: '4px'
  },
  statementRowDesc: {
    marginLeft: '20px'
  }
}));
export default useStyles;